import PropTypes from "prop-types";

import {
  FormSkeleton,
  useCustomFieldConfigs,
  useCustomFieldGroups,
} from "components/BaseForm";
import { useCampaign } from "hooks/useCampaign";
import CampaignForm from "routes/campaign/form/CampaignForm";
import { MODEL_TYPE } from "routes/campaign/form/constants";
import { FORM_MODES } from "routes/campaign/form/defaults";

/** Loads a campaign by id, or none, and mounts the Campaign form for it. */
const CampaignFormLoader = ({ id, onSaved, onCancel }) => {
  const campaignQuery = useCampaign(id);
  const configsQuery = useCustomFieldConfigs(MODEL_TYPE);
  const groupsQuery = useCustomFieldGroups(MODEL_TYPE);

  if (campaignQuery.isError || configsQuery.isError || groupsQuery.isError) {
    return <p>Could not load the form.</p>;
  }

  const isLoading =
    (id && !campaignQuery.isFetchedAfterMount) ||
    configsQuery.isPending ||
    groupsQuery.isPending;

  if (isLoading) {
    return <FormSkeleton sections={4} className="tw:max-w-7xl" />;
  }

  return (
    <CampaignForm
      mode={id ? FORM_MODES.edit : FORM_MODES.create}
      record={campaignQuery.data}
      customFieldConfigs={configsQuery.data ?? []}
      customFieldGroups={groupsQuery.data ?? []}
      onSaved={onSaved}
      onCancel={onCancel}
    />
  );
};

CampaignFormLoader.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSaved: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default CampaignFormLoader;
